import apiClient from "./axios"

export const getServiceLists = async (params = {}) => {
  const { data } = await apiClient.get("/v1/service-lists", { params })
  return data
}

export const getServiceList = async (id) => {
  const { data } = await apiClient.get(`/v1/service-lists/${id}`)
  return data
}

export const createServiceList = async (payload) => {
  const { data } = await apiClient.post("/v1/service-lists", payload)
  return data
}

export const updateServiceList = async ({ id, ...payload }) => {
  const { data } = await apiClient.put(`/v1/service-lists/${id}`, payload)
  return data
}

export const deleteServiceList = async (id) => {
  const { data } = await apiClient.delete(`/v1/service-lists/${id}`)
  return data
}
